'use es6';

import { getIsUngated, getIsUngatedForFeatureStore, getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { transformState } from './SelectorUtils';
export const isUngatedSelector = createSelectorFromUtil(getIsUngated, transformState);
export const isUngatedForFeatureStore = createSelectorFromUtil(getIsUngatedForFeatureStore, transformState);
export const isUngatedForSeatsSelector = createSelectorFromUtil(getIsUngatedForSeats, transformState);